<div>
  <app-empty-message
		*ngIf="!fileUrl"
		icon="./assets/icon/empty-files.svg"
		[message]="'The file you requested could not be opened' | translate"
	></app-empty-message>
  <pdf-viewer
      [src]="fileUrl"
      [render-text]="true"
      (error) ="showPlaceholder()"
  >
  </pdf-viewer>
</div>